<template>
  <section class="mission-vision position-relative see__pad">
    <div class="pattern-layer">
      <div class="pattern-5 position-absolute" style="background-image: url('/shapes/shape-07.png')"></div>
    </div>
    <div class="pattern-layer">
      <div class="pattern-6 position-absolute" style="background-image: url('/shapes/shape-08.png')"></div>
    </div>
    <div class="pattern-layer">
      <div class="pattern-7 position-absolute" style="background-image: url('/shapes/shape-09.png')"></div>
    </div>
    <div class="pattern-layer">
      <div class="pattern-8 position-absolute" style="background-image: url('/shapes/shape-10.png')"></div>
    </div>

    <div class="header-container">
      <div class="row">
        <div class="col-lg-12">
          <div class="mission-header text-center">
            <div class="mission-section-label">
              <h4>{{ content.header.sectionLabel }}</h4>
            </div>
            <div class="mission-main-title">
              <h2>{{ content.header.mainTitle }}</h2>
            </div>
            <div class="mission-description">
              <p>{{ content.header.description }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="header-container">
      <div class="row">
        <div class="col-lg-6 col-md-6 mb-4">
          <div class="mission-item">
            <div class="mission-bg">
              <div class="block-shape-1"></div>
              <div class="block-shape-2"></div>
            </div>
            <div class="mission-content">
              <div class="mission-icon">
                <i :class="content.mission.icon"></i>
              </div>
              <h3>{{ content.mission.title }}</h3>
              <p>{{ content.mission.description }}</p>
              <div class="mission-features">
                <div class="feature-item" v-for="(feature, index) in content.mission.features" :key="index">
                  <i class="icon-03"></i>
                  <span>{{ feature }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-lg-6 col-md-6 mb-4">
          <div class="vision-item">
            <div class="vision-bg">
              <div class="block-shape-1"></div>
              <div class="block-shape-2"></div>
            </div>
            <div class="vision-content">
              <div class="vision-icon">
                <i :class="content.vision.icon"></i>
              </div>
              <h3>{{ content.vision.title }}</h3>
              <p>{{ content.vision.description }}</p>
              <div class="vision-features">
                <div class="feature-item" v-for="(feature, index) in content.vision.features" :key="index">
                  <i class="icon-03"></i>
                  <span>{{ feature }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'AboutMissionVisionComp',
  props: {
    content: {
      type: Object,
      required: true
    }
  }
}
</script>

<style scoped>
/* Import Google Fonts */
@import url('https://fonts.googleapis.com/css2?family=Archivo:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&family=Open+Sans:ital,wght@0,300;0,400;0,500;0,600;0,700;0,800;1,300;1,400;1,500;1,600;1,700;1,800&display=swap');

/* Import Flaticon */
@import '@/assets/scss/Flaticon.scss';

.see__pad {
  padding: 100px 0;
}

.header-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 15px;
}

/* Pattern Layers */
.pattern-layer {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1;
}

.pattern-5 {
  bottom: 25%;
  right: 20%;
  width: 70px;
  height: 70px;
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
  opacity: 0.1;
}

.pattern-6 {
  top: 40%;
  left: 5%;
  width: 110px;
  height: 110px;
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
  opacity: 0.09;
}

.pattern-7 {
  bottom: 15%;
  left: 12%;
  width: 85px;
  height: 85px;
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
  opacity: 0.08;
}

.pattern-8 {
  top: 35%;
  right: 8%;
  width: 95px;
  height: 95px;
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
  opacity: 0.1;
}

/* Mission & Vision Section */
.mission-vision {
  background: #00061A;
  position: relative;
  overflow: hidden;
}

.mission-header {
  position: relative;
  z-index: 2;
  margin-bottom: 60px;
}

.mission-section-label h4 {
  font-size: 20px;
  font-weight: 400;
  letter-spacing: 13.2px;
  color: #F6EC4F;
  margin-bottom: 20px;
  font-family: 'Archivo', sans-serif;
  text-transform: uppercase;
}

.mission-main-title h2 {
  font-size: 48px;
  font-weight: 700;
  line-height: 58px;
  color: #fff;
  margin-bottom: 20px;
  font-family: 'Archivo', sans-serif;
}

.mission-description p {
  font-size: 18px;
  color: #fff;
  max-width: 800px;
  margin: 0 auto;
  line-height: 1.8;
}

.mission-item,
.vision-item {
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(246, 236, 79, 0.1);
  border-radius: 15px;
  padding: 40px 30px;
  height: 100%;
  position: relative;
  transition: all 0.3s ease;
  overflow: hidden;
}

.mission-item:hover,
.vision-item:hover {
  transform: translateY(-10px);
  box-shadow: 0 25px 50px rgba(246, 236, 79, 0.2);
  border-color: #F6EC4F;
}

.mission-bg,
.vision-bg {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1;
}

.block-shape-1 {
  position: absolute;
  top: -20px;
  right: -20px;
  width: 100px;
  height: 100px;
  background: linear-gradient(135deg, rgba(246, 236, 79, 0.1), rgba(246, 236, 79, 0.05));
  border-radius: 50%;
  opacity: 0.3;
}

.block-shape-2 {
  position: absolute;
  bottom: -30px;
  left: -30px;
  width: 80px;
  height: 80px;
  background: linear-gradient(45deg, rgba(246, 236, 79, 0.08), rgba(246, 236, 79, 0.03));
  border-radius: 50%;
  opacity: 0.4;
}

.mission-content,
.vision-content {
  position: relative;
  z-index: 2;
}

.mission-icon,
.vision-icon {
  width: 60px;
  height: 60px;
  background: linear-gradient(135deg, #F6EC4F, #E6D43A);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 25px;
}

.mission-icon i,
.vision-icon i {
  font-size: 24px;
  color: #00061A;
}

.mission-content h3,
.vision-content h3 {
  font-size: 24px;
  font-weight: 600;
  color: #fff;
  margin-bottom: 15px;
  font-family: 'Archivo', sans-serif;
}

.mission-content p,
.vision-content p {
  font-size: 16px;
  color: #fff;
  margin-bottom: 25px;
  line-height: 1.6;
}

.mission-features,
.vision-features {
  margin-bottom: 25px;
}

.feature-item {
  display: flex;
  align-items: center;
  margin-bottom: 12px;
}

.feature-item i {
  color: #F6EC4F;
  margin-right: 10px;
  font-size: 14px;
}

.feature-item span {
  color: #fff;
  font-size: 14px;
}

/* Responsive Design */
@media only screen and (max-width: 991px) {
  .mission-vision {
    padding: 80px 0;
  }
}

@media only screen and (max-width: 767px) {
  .mission-vision {
    padding: 60px 0;
  }
  
  .mission-main-title h2 {
    font-size: 36px;
    line-height: 46px;
  }
  
  .mission-section-label h4 {
    letter-spacing: 8px;
    font-size: 16px;
  }
  
  .mission-item,
  .vision-item {
    padding: 30px 20px;
  }
}

@media only screen and (max-width: 399px) {
  .mission-vision {
    padding: 40px 0;
  }
  
  .mission-main-title h2 {
    font-size: 28px;
    line-height: 38px;
  }
}
</style>
